import { render, staticRenderFns } from "./SubjectSummary.vue?vue&type=template&id=9da8bff2&scoped=true&"
import script from "./SubjectSummary.vue?vue&type=script&lang=js&"
export * from "./SubjectSummary.vue?vue&type=script&lang=js&"
import style0 from "./SubjectSummary.vue?vue&type=style&index=0&id=9da8bff2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da8bff2",
  null
  
)

export default component.exports